import createIcon from '../../createIcon';

/**
 * @component @name PhoneAndroid
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMUg4QzYuMzQgMSA1IDIuMzQgNSA0VjIwQzUgMjEuNjYgNi4zNCAyMyA4IDIzSDE2QzE3LjY2IDIzIDE5IDIxLjY2IDE5IDIwVjRDMTkgMi4zNCAxNy42NiAxIDE2IDFaTTE0IDIxSDEwVjIwSDE0VjIxWk0xNy4yNSAxOEg2Ljc1VjRIMTcuMjVWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhoneAndroid = createIcon('PhoneAndroid', [
  [
    'path',
    {
      d: 'M16 1H8C6.34 1 5 2.34 5 4V20C5 21.66 6.34 23 8 23H16C17.66 23 19 21.66 19 20V4C19 2.34 17.66 1 16 1ZM14 21H10V20H14V21ZM17.25 18H6.75V4H17.25V18Z',
      key: '5wxp9h',
    },
  ],
]);

export default PhoneAndroid;
